import { Link } from 'react-router-dom';
import { castMembers } from '@/mocks/castMembers';

export default function CastStrip() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-primary-600">CAST</p>
            <h2 className="mt-2 font-heading text-xl text-foreground-950 md:text-2xl">主创阵容</h2>
          </div>
          <Link
            to="/category/cast"
            className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
          >
            全部演员资料
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="no-scrollbar mt-6 flex gap-4 overflow-x-auto pb-2">
          {castMembers.map((member) => (
            <Link
              key={member.id}
              to={`/detail/cast/${member.id}`}
              className="group w-[150px] shrink-0 sm:w-[170px]"
            >
              <div className="h-[200px] w-full overflow-hidden rounded-lg bg-background-200 sm:h-[226px]">
                <img
                  src={member.image}
                  alt={`演员${member.name}饰演${member.role}`}
                  title={`${member.name} - 禁止的爱善良的小姨子演员`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <p className="mt-3 font-heading text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                {member.name}
              </p>
              <p className="mt-1 text-xs text-foreground-500">饰 {member.role}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}